
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/values",
      function () {
        return require("private-next-pages/[market]/[language]/values.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/values"])
      });
    }
  